import { DialogOpenEvent } from '@theme/dialog';
import { isClickedOutside } from '@theme/utilities';

/** @param {HTMLElement} root */
function bindWatchNow(root) {
  if (root.dataset.watchNowBound === 'true') return;
  root.dataset.watchNowBound = 'true';

  const dialog = root.querySelector('dialog');
  const player = root.querySelector('[data-watch-now-player]');
  const uploadTpl = root.querySelector('template[data-watch-now-upload]');

  /** @type {(() => void) | undefined} */
  let removeOutsideClick;

  function mountPlayer() {
    if (!player) return;
    player.replaceChildren();

    const id = root.dataset.watchNowVideoId;
    if (id) {
      const type = root.dataset.watchNowVideoType || 'youtube';
      const loop = root.dataset.watchNowVideoLoop === 'true';
      const iframe = document.createElement('iframe');
      iframe.className = 'watch-now-modal__iframe';
      iframe.title = root.dataset.watchNowVideoAlt || 'Video';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.src =
        type === 'vimeo'
          ? `https://player.vimeo.com/video/${id}?autoplay=1&playsinline=1${loop ? '&loop=1' : ''}`
          : `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1&rel=0${loop ? `&loop=1&playlist=${id}` : ''}`;
      player.appendChild(iframe);
      return;
    }

    if (uploadTpl instanceof HTMLTemplateElement) {
      player.appendChild(uploadTpl.content.cloneNode(true));
    }
  }

  /** @param {MouseEvent} event */
  function onOutsideClick(event) {
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
    if (!isClickedOutside(event, dialog)) return;
    /** @type {{ closeDialog?: () => void }} */ (root).closeDialog?.();
  }

  root.addEventListener(DialogOpenEvent.eventName, () => {
    requestAnimationFrame(() => {
      mountPlayer();
      document.addEventListener('click', onOutsideClick, true);
      removeOutsideClick = () => document.removeEventListener('click', onOutsideClick, true);
    });
  });

  dialog?.addEventListener('close', () => {
    removeOutsideClick?.();
    removeOutsideClick = undefined;
    player?.replaceChildren();
  });
}

/** @param {ParentNode} [scope] */
function initWatchNow(scope = document) {
  scope.querySelectorAll?.('dialog-component.watch-now').forEach((el) => {
    if (el instanceof HTMLElement) bindWatchNow(el);
  });
}

initWatchNow();
document.addEventListener('shopify:section:load', (e) => {
  if (e.target instanceof HTMLElement) initWatchNow(e.target);
});
document.addEventListener('shopify:block:select', (e) => {
  if (e.target instanceof HTMLElement) initWatchNow(e.target);
});
